import {debounce} from 'lodash'
import React, {Fragment, useRef, useMemo, useState, useCallback} from 'react'
import {Layer, Rect, Group, Transformer} from 'react-konva'
import {actionChangeSelectedLayer, updateLayerAttribute, actionToggleCropMode} from '../../context/SelectedVariantContext/action'
import {handleCalculateDpi} from '../../context/SelectedVariantContext/helper'
import BackgroundLayer from './BackgroundLayer'
import TextLayer from './TextLayer'
import ImageLayer from './ImageLayer'

const MockupLayers = ({
    background,
    layers,
    draggable,
    dispatch,
    selectedLayer,
    selection,
    rectRefs,
    selectedIds,
    transformerRef,
    cropMode,
    editorWrapper,
    productCreatedType,
    selectedSide,
    side,
    loadingImageLayer
}) => {
    const layerRef = useRef(null)

    return (
        <>
            <Layer ref={layerRef} listening={!draggable}>
                <BackgroundLayer
                    onClick={() => dispatch(actionChangeSelectedLayer())}
                    imageProps={background}
                    isBackground={true}
                    zIndexDefault={0}
                />
                <BackgroundLayer
                    onClick={() => dispatch(actionChangeSelectedLayer())}
                    ck
                    imageProps={background}
                    zIndexDefault={1}
                />
                {/* {
                    productCreatedType === 'regularNoTemplate' && (
                        <Rect
                            x={editorWrapper.width / 2 - 230}
                            y={editorWrapper.height / 2 - 230}
                            width={460}
                            height={460}
                            fill="white"
                            shadowBlur={3}
                        />
                    )
                } */}
                {
                    (productCreatedType === 'regularHasTemplate' || productCreatedType === 'combineLayout') && (
                        <Rect
                            x={0}
                            y={0}
                            width={1000}
                            height={1000}
                            fill="#ffffff"
                            stroke="#D8DBDE"
                            strokeWidth={20}
                            {...background}
                        />
                    )
                }
                {layers?.map((layer, i) => {
                    const isSelected = layer.id === selectedLayer?.id
                    const props = {
                        key: layer.id,
                        zIndexDefault: i + 2,
                        isSelected,
                        onChange: (layer, updateHistory = true) => {
                            dispatch(updateLayerAttribute(layer, updateHistory))
                        },
                        onSelect: debounce(() => {
                            if (!isSelected) {
                                // const dpi = layer.imageType !== 'image/svg+xml'?  handleCalculateDpi(layer): undefined
                                // const attrs = {
                                //     ...layer,
                                //     dpi: layer.imageType !== 'image/svg+xml'? dpi : undefined,
                                // }
                                dispatch(actionChangeSelectedLayer(layer))
                                dispatch(actionToggleCropMode(false))
                            }
                        }, 100),
                        background,
                        rectRefs, // Pass rectRefs to layers
                        layerId: layer.id, // Pass layer ID for registration
                        transformerRef, // Pass transformerRef
                    }

                    return layer.layerType === 'text' ? (
                        <TextLayer {...props} textProps={layer} />
                    ) : (
                        <ImageLayer
                            {...props}
                            side={side}
                            selectedSide={selectedSide}
                            imageProps={layer}
                            dispatch={dispatch}
                            onChangeSizeImage={debounce((newSize) => {
                                let newAttrs = {...layer, ...newSize}
                                if (layer.imageType !== 'image/svg+xml') {
                                    const dpi = handleCalculateDpi(newAttrs)
                                    newAttrs = {...newAttrs, dpi}
                                    dispatch(actionChangeSelectedLayer(newAttrs))
                                }
                            }, 100)}
                            cropMode={cropMode}
                            productCreatedType={productCreatedType}
                            loadingImageLayer={loadingImageLayer}
                        />
                    )
                })}

                {/* Selection rectangle for drag selection */}
                {selection?.visible && (
                    <Rect
                        x={selection.x}
                        y={selection.y}
                        width={selection.width}
                        height={selection.height}
                        fill="rgba(0,123,255,0.2)"
                        stroke="rgba(0,123,255,0.8)"
                        strokeWidth={1}
                        listening={false}
                        dash={[5, 5]}
                    />
                )}

                <Transformer
                    ref={transformerRef}
                    enabledAnchors={['top-left', 'top-right', 'bottom-left', 'bottom-right']}
                    // resizeEnabled={false}
                    rotateEnabled={false}
                    flipEnabled={false}
                    anchorCornerRadius={30}
                    rotateAnchorOffset={20}
                    anchorStrokeWidth={2}
                    draggable={false}
                    boundBoxFunc={(oldBox, newBox) => {
                        return newBox
                    }}
                />

                <BackgroundLayer
                    onClick={() => dispatch(actionChangeSelectedLayer())}
                    imageProps={background}
                    showImage={true}
                    name="background"
                />
            </Layer>
        </>
    )
}

export default MockupLayers

